import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

function DangerousGoods({
  onClose,
  valorActualExpo,
  actualizarTarifa,
  concepto,
}) {
  const [tres, setTres] = useState("");
  const [uno, setUno] = useState("");
  const [notoc, setNotoc] = useState("");

  // 🔹 Cargar datos simulados del back
  useEffect(() => {
    if (valorActualExpo) {
      setTres(valorActualExpo.tres || "");
      setUno(valorActualExpo.uno || "");
      setNotoc(valorActualExpo.notoc || "");
    }
  }, [valorActualExpo]);

  const handleActualizar = () => {
    actualizarTarifa(concepto, {
      tres,
      uno,
      notoc: notoc,
    });

    Swal.fire({
      title: "Éxito",
      text: "Datos actualizados correctamente",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-left" style={{ width: "450px" }}>
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              Mercancias Peligrosas con hasta 3 números de UN (MXN)
            </label>
            <input
              type="number"
              className="form-control"
              value={tres}
              onChange={(e) => setTres(e.target.value)}
            />
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              Por cada UN adicional (MXN)
            </label>
            <input
              type="number"
              className="form-control"
              value={uno}
              onChange={(e) => setUno(e.target.value)}
            />
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              Mercancias Peligrosas exentas de DGD, Lista de Verficación, NOTOC (USD)
            </label>
            <input
              type="number"
              className="form-control"
              value={notoc}
              onChange={(e) => setNotoc(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default DangerousGoods;
